import { Container } from "unstated";

interface IState {
  isOnline: boolean;
  hasChecked: boolean;
  props: {};
}

const initialState: IState = {
  hasChecked: true,
  isOnline: false,
  props: {}
};

class ConnectionStatus extends Container<IState> {
  public state = initialState;

  public checkOnline = () => {
    if (this.state.isOnline !== window.navigator.onLine) {
      this.setState({ isOnline: window.navigator.onLine, hasChecked: true });
    }
  };

  public setOnline = () => {
    if (!this.state.isOnline) {
      this.setState({ isOnline: true });
    }
  };

  public setOffline = () => {
    if (this.state.isOnline) {
      this.setState({ isOnline: false });
    }
  };
}

export default ConnectionStatus;
